/**
 * Utility functions to validate different types of values.
 */

export const isNullOrEmpty = (value) => {
    return value == null || value === undefined || value === '';
};

export const isNullOrEmptyOrZero = (value) => {
    return value == null || value === undefined || value === '' || value === 0;
};

export const isValidNumber = (value) => {
    return !isNaN(value) && value !== null && value !== undefined;
};

export const isValidString = (value) => {
    return typeof value === 'string' && value.trim() !== '';
};

export const isValidArray = (value) => {
    return Array.isArray(value) && value.length > 0;
};

export const isValidObject = (value) => {
    return value && typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length > 0;
};